import React from 'react'
import GoogleLogo from '../Logos/GoogleLogo'
import CalendlyLogo from '../Logos/CalendlyLogo'

function SignInWithService({
  onClick,
  service,
  text
}) {
  return (
    <button onClick={onClick} className={`relative py-3 flex items-center hover:bg-gray-100 bg-white border rounded px-2 w-full`}>
      {service === 'google' && <GoogleLogo className='ml-2 w-7 h-7 absolute'/>}
      {service === 'calendly' && <CalendlyLogo className='ml-2 w-7 h-7 absolute'/>}
      <span className='flex-grow'>{text}</span>
    </button>
  )
}

export default SignInWithService
